import React from 'react';

export const ServicesSection: React.FC = () => {
  const services = [
    {
      image: 'https://public.readdy.ai/ai/img_res/508ca13d7609f58973ce43c75c7fb6b5.jpg',
      title: 'AI Consulting & Automation',
      description: 'Transform your business with cutting-edge AI solutions and workflow automation strategies.',
      features: ['Process Automation', 'AI Implementation', 'Workflow Optimization', 'Digital Transformation']
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Business%20development%20and%20strategic%20growth%20concept%20with%20upward%20trending%20charts%2C%20professional%20corporate%20environment%2C%20modern%20office%20setting%20with%20growth%20analytics%2C%20strategic%20planning%20visualization%20with%20blue%20and%20green%20business%20themes&width=400&height=300&seq=business-development-service-001&orientation=landscape',
      title: 'Business Development',
      description: 'Strategic guidance to accelerate growth and maximize your business potential.',
      features: ['Strategic Planning', 'Market Analysis', 'Growth Strategies', 'Performance Optimization']
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Real%20estate%20investment%20and%20property%20development%20concept%20with%20modern%20buildings%20and%20investment%20charts%2C%20professional%20real%20estate%20portfolio%20visualization%2C%20luxury%20property%20investment%20background%20with%20financial%20growth%20elements&width=400&height=300&seq=real-estate-service-001&orientation=landscape',
      title: 'Real Estate Investment',
      description: 'Expert advice on property investment strategies and market opportunities.',
      features: ['Investment Analysis', 'Market Research', 'Portfolio Management', 'Risk Assessment']
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Author%20and%20publishing%20services%20concept%20with%20open%20books%20and%20writing%20materials%2C%20professional%20publishing%20environment%2C%20modern%20library%20setting%20with%20books%20and%20digital%20publishing%20elements%2C%20literary%20success%20visualization&width=400&height=300&seq=publishing-service-001&orientation=landscape',
      title: 'Author & Publishing',
      description: 'Comprehensive publishing services from manuscript to market success.',
      features: ['Content Strategy', 'Publishing Guidance', 'Marketing Support', 'Platform Building']
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Construction%20management%20and%20consulting%20concept%20with%20construction%20site%2C%20hard%20hats%20and%20blueprints%2C%20professional%20construction%20project%20management%20visualization%2C%20modern%20building%20development%20with%20safety%20equipment%20and%20planning%20documents&width=400&height=300&seq=construction-consulting-service-001&orientation=landscape',
      title: 'Construction Consulting',
      description: 'Leverage 40 years of construction management expertise for your projects.',
      features: ['Project Management', 'Cost Estimation', 'Quality Control', 'Risk Mitigation']
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Travel%20planning%20and%20destination%20management%20concept%20with%20world%20map%20and%20travel%20accessories%2C%20professional%20travel%20consultation%20environment%2C%20luxury%20travel%20planning%20visualization%20with%20passport%2C%20tickets%20and%20destination%20imagery&width=400&height=300&seq=travel-planning-service-001&orientation=landscape',
      title: 'Travel Planning',
      description: 'Personalized travel experiences and comprehensive trip planning services.',
      features: ['Itinerary Planning', 'Booking Management', 'Travel Optimization', 'Experience Curation']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Comprehensive Business Development Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our integrated approach combines corporate governance expertise, strategic client acquisition, and partnership development to drive sustainable revenue growth for your organization.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group">
              <div className="relative overflow-hidden">
                <img 
                  alt={service.title} 
                  className="w-full h-48 object-cover object-top group-hover:scale-110 transition-transform duration-300" 
                  src={service.image}
                />
                <div className="absolute inset-0 bg-blue-600/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-blue-600 transition-colors">{service.title}</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
                <ul className="space-y-2">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center text-gray-700">
                      <i className="ri-check-line text-green-500 mr-3"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};